import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IAttendaceList } from "./AttendanceMark";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { ILogin, IPermissionProps } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    toast?: any,
    filters?: any,
    user_ID?: number,
}

export const AttendanceHistoryTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IAttendaceList[], loading: boolean });
    const dt = useRef<any>();

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0"></h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                {/* <Search setSearch={setGlobalFilter} /> */}
            </span>
        </div>
    );

    const loadData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let queryParam = props.user_ID ? `user_id=${props.user_ID}` : null;
        if (props.filters) {
            queryParam = queryParam === null ? `filter=${JSON.stringify(props.filters)}` : queryParam + `&filter=${JSON.stringify(props.filters)}`;
        }

        const response = await Fetch("attendance_mark", "GET", null, queryParam, props.toast);
        if (response) {
            const data: IAttendaceList[] = await response.json();
            setTableData({ tableData: data, loading: false });
            // toast.current.show({ severity: 'success', detail: "", life: 3000 });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    };

    useEffect(() => {
        loadData();

        return () => setTableData({ tableData: [], loading: false });
    }, [props.filters]);


    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
            ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
            value={tableData.tableData}
            emptyMessage="No Branches found."
            header={header}
            loading={tableData.loading}
        >
            <Column field="user_Name" header="User Name" />
            <Column field="attendance" header="Present" body={(e) => <p>{e.attendance ? "No" : "Yes"}</p>} />
            {/* <Column field="created_On" header="Date" body={(e) => <p>{e.created_On.split("T")[0]}{" | "}{(Number(e.created_On.split("T")[1].split(":")[0]) <= 12 ? Number(e.created_On.split("T")[1].split(":")[0]) : Number(e.created_On.split("T")[1].split(":")[0]) - 12) + ":" + e.created_On.split("T")[1].split(":")[1]} {Number(e.created_On.split("T")[1].split(":")[0]) < 12 ? "AM" : "PM"}</p>} /> */}
            <Column field="created_On" header="Date" body={(rowData: any) => safeFormatDate(rowData.created_On, 'dd/MM/yyyy', DateFormat, true,)} />
            <Column field="added_By_Name" header="Added By" />
        </DataTable>
    );
}